import styled, { css } from 'styled-components'

export const TrayContainer = styled.div`
  display: none;
  max-height: 0;
  min-width: 180px;
  overflow: visible;
  z-index: 10000;
  position: absolute;
  top: 48px;
  left: 0;

  ${({ open }) =>
    open &&
    css`
      display: block;
    `}
`
